import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { bindPopover, usePopupState } from "material-ui-popup-state/hooks";
import React from "react";
import { useGetDatevUserInfo } from "../../client/hooks";
import { useQuery } from "react-query";
import { useT } from "../../i18n";

function ExterneSystemeUserButton() {
  const getDatevUserInfo = useGetDatevUserInfo();
  const { t } = useT("externesysteme");

  const { data: datevUserInfo, isLoading } = useQuery(
    ["externesysteme", "datevUserInfo"],
    () =>
      getDatevUserInfo().catch((e) => {
        console.error("Error while fetching datev user info: ", e.message);
        return null;
      }),
    {
      refetchOnWindowFocus: false,
    }
  );

  const popupState = usePopupState({
    variant: "popover",
    popupId: `datev-user-info`,
  });

  return (
    <>
      <Button
        onClick={(event) => {
          event.stopPropagation();
          popupState.open();
        }}
        color={"info"}
        title={"User Info"}
      >
        <AccountCircle />
      </Button>
      <Dialog {...bindPopover(popupState)}>
        <DialogTitle id="alert-dialog-title">{t("datev-user")}</DialogTitle>
        <DialogContent>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <>
              {datevUserInfo ? (
                <>
                  <Typography>Name: {datevUserInfo?.name} </Typography>
                  <Typography>ClientId: {datevUserInfo?.id} </Typography>
                </>
              ) : (
                <Typography> User not found </Typography>
              )}
              <br />
              <Typography>
                {t("additional-information")}
                {": "}
                <a href="https://apps.datev.de/tokrevui">
                  https://apps.datev.de/tokrevui
                </a>
              </Typography>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default ExterneSystemeUserButton;
